import { Loader } from '@components/loader';
import { ApiKeys } from '@pages/apiKeys';
import { ApiKeyType } from '@root/globalTypes';
import { useDisableApiKey } from '@services/acquirer/apiKeys/disable';
import { useListApiKeys } from '@services/acquirer/apiKeys/list';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { Row } from '@tanstack/react-table';

const AcquirerApiKeys = () => {
  const navigate = useNavigate();
  const { localId } = useParams({ from: '/u/$localId/_acquirer/acquirer/api-keys/' });
  const { data, isPending } = useListApiKeys();
  const { mutate: disableApiKey, isPending: disabling } = useDisableApiKey();

  function handleSelect(row: Row<ApiKeyType>) {
    const id: string = row.original.id;

    navigate({ to: '/u/$localId/acquirer/api-keys/$id', params: { id, localId } }).catch((err) =>
      console.error(err),
    );
  }

  function newRedirect() {
    navigate({ to: '/u/$localId/acquirer/api-keys/new', params: { localId } }).catch((err) =>
      console.error(err),
    );
  }

  if (isPending) return <Loader />;

  return (
    <ApiKeys
      data={data}
      onDisable={disableApiKey}
      disabling={disabling}
      newRedirect={newRedirect}
      onRowSelect={handleSelect}
      createPermission="acquirer_api_keys_create"
      disablePermission="acquirer_api_keys_disable"
    />
  );
};

export const Route = createFileRoute('/u/$localId/_acquirer/acquirer/api-keys/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['acquirer_api_keys_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: AcquirerApiKeys,
});
